import { render, staticRenderFns } from "./GenericProductQuestions.vue?vue&type=template&id=0b74e4cb&scoped=true"
import script from "./GenericProductQuestions.vue?vue&type=script&lang=js"
export * from "./GenericProductQuestions.vue?vue&type=script&lang=js"
import style0 from "./GenericProductQuestions.vue?vue&type=style&index=0&id=0b74e4cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b74e4cb",
  null
  
)

export default component.exports